(function () {
  function getLimit(input) {
    return parseInt(input.getAttribute("maxlength"), 10) || 20;
  }

  function countUsed(val, limit) {
    return Math.min((val || "").length, limit);
  }

  function ensureCounter(component, input, limit) {
    // Hide Rebel’s built-in counter text
    component.querySelectorAll("p, span, small, div, label").forEach((el) => {
      const txt = (el.textContent || "").trim();
      if (/^\d+\s*\/\s*\d+\s*characters used$/i.test(txt) && !el.querySelector("input, textarea")) {
        el.style.display = "none";
      }
    });

    // Create our own counter if it doesn't exist
    let ours = component.querySelector(".ll-custom-counter");
    if (!ours) {
      ours = document.createElement("p");
      ours.className = "ll-custom-counter";
      ours.style.marginTop = "6px";
      ours.style.fontSize = "12px";
      ours.style.opacity = "0.75";

      const fieldWrap = input.closest(".field") || input.parentElement || component;
      fieldWrap.appendChild(ours);
    }

    ours.textContent = `${countUsed(input.value, limit)}/${limit} characters used`;
    return ours;
  }

  function apply(component) {
    const input = component.querySelector("input, textarea");
    if (!input) return;

    const limit = getLimit(input);

    // Prevent double-binding
    if (input.dataset.llCounterApplied === "true") return;
    input.dataset.llCounterApplied = "true";

    input.maxLength = limit;

    const ours = ensureCounter(component, input, limit);

    const update = () => {
      const currentLimit = getLimit(input);

      if (input.value.length > currentLimit) {
        input.value = input.value.slice(0, currentLimit);
      }

      ours.textContent = `${countUsed(input.value, currentLimit)}/${currentLimit} characters used`;
    };

    input.addEventListener("input", update);
    update();
  }

  function init() {
    document.querySelectorAll("product-custom-property-component").forEach(apply);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:select", init);

  const obs = new MutationObserver(() => init());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();